import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { ChangePass } from '../model/change-pass';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { ChangePassEventType } from '../change-pass.event.type';
import { TweenMax, Quint } from 'gsap';

@Component({
	selector: 'app-summary',
	templateUrl: './summary.component.html',
	styleUrls: ['./summary.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SummaryComponent implements OnInit, OnDestroy {

	@Input() changePassData: ChangePass;
	private view = '[data-component="summary"]';
	active = false;

	constructor() { }

	ngOnInit() {
		AppEventDispatcher.listen(ChangePassEventType.STEPS.CHANGE_PASS_WARNING, data => {

			if (data.show) {
				this.active = true;
				this.show();
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangePassEventType.STEPS.CHANGE_PASS_WARNING);
	}

	show() {

		AppEventDispatcher.dispatch(ChangePassEventType.BUTTONS, { show: false });

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
		});

	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-pass/summary/summary.component.ts